import { render, staticRenderFns } from "./TotalEditFilters.vue?vue&type=template&id=435af297"
import script from "./TotalEditFilters.vue?vue&type=script&lang=ts"
export * from "./TotalEditFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435af297')) {
      api.createRecord('435af297', component.options)
    } else {
      api.reload('435af297', component.options)
    }
    module.hot.accept("./TotalEditFilters.vue?vue&type=template&id=435af297", function () {
      api.rerender('435af297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/TotalEditFilters.vue"
export default component.exports